import type { Article } from "@/types/content";

interface ArticleBodyProps {
  article: Article;
}

export default function ArticleBody({ article }: ArticleBodyProps) {
  return (
    <article className="rounded-card border border-background-200/80 bg-background-50 p-5 md:p-9">
      <div className="rounded-xl border border-accent-300/60 bg-accent-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-flashlight-line text-accent-700"></i>
          </span>
          速览要点
        </h2>
        <ul className="mt-3 flex flex-col gap-2">
          {article.keyPoints.map((point) => (
            <li key={point} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500"></span>
              {point}
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-8 flex flex-col gap-8">
        {article.sections.map((section, index) => (
          <section key={section.heading} id={`section-${index}`} className="scroll-mt-28">
            <h2 className="flex items-start gap-3 font-heading text-lg font-bold text-foreground-950 md:text-xl">
              <span className="mt-0.5 font-heading text-base font-black text-primary-500">
                {String(index + 1).padStart(2, "0")}
              </span>
              {section.heading}
            </h2>
            <div className="mt-3 flex flex-col gap-4">
              {section.paragraphs.map((paragraph) => (
                <p
                  key={paragraph.slice(0, 24)}
                  className="text-sm leading-[1.9] text-foreground-700 md:text-[15px]"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-9 flex flex-wrap gap-2 border-t border-background-200/70 pt-5">
        <span className="text-xs text-foreground-500">相关标签：</span>
        {article.tags.map((tag) => (
          <span
            key={tag}
            className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-800"
          >
            {tag}
          </span>
        ))}
      </div>

      <p className="mt-5 rounded-xl bg-background-100 px-4 py-3 text-xs leading-relaxed text-foreground-500">
        内容说明：本文为娱乐话题整理，涉及人物与事件均为站内设定。对尚未被回应的信息，我们只做客观呈现，不做结论性判断，请理性吃瓜。
      </p>
    </article>
  );
}